import React from "react";
import { Formik } from "formik";
import { TextField, Paper, withStyles, Button, Typography, CircularProgress, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import * as Yup from "yup";
import { BackButton } from '../../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootEdit: {
        width: `98.7%`,
        padding: theme.spacing(2),

        height: 'auto',
        marginTop: '5px',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

const ProjectForm = props => {
    const { classes, formSettings, initialValues, edit, handleSubmit, translations, groups } = props;
    return (
        <Paper className={edit ? classes.rootEdit : classes.root}>
            {edit ? null : BackButton(translations)}
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize={true}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations['name'] || 'Name'}
                                label={translations['name'] || 'Name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="FancyName"
                                value={values.FancyName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.FancyName && touched.FancyName)}
                                placeholder={translations['fancy_name'] || 'Fancy name'}
                                label={translations['fancy_name'] || 'Fancy name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["group"] || "Group"}</InputLabel>
                                <Select
                                    name="GroupID"
                                    label={translations["group"] || "Group"}
                                    margin={"dense"}
                                    value={values.GroupID}
                                    onChange={handleChange}
                                >
                                    {(groups ? [...groups] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};
export default withStyles(styles, { withTheme: true })(ProjectForm);
